import { message } from 'antd';
import { useSelector } from 'react-redux';
import html2canvas from 'html2canvas';
import moment from "moment-timezone";
import JsPDF from 'jspdf';
import { setEditCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { getAxiosInstance } from '../../../Api/ApiConfig';
import { FecthModuleEncryptedToken, FecthModuleDecryptedToken } from '../../../Api/Services/CommonApiService';

export const DropDownFilterCondition = (item, field, condition, value) => {
    switch (condition) {
        case "=":
            // return item[field] === value;
            return value.includes(item[field]);
        case "!=":
            // return item[field] !== value;
            return !value.includes(item[field]);
        case "IS NULL":
            return item[field] === null || item[field] === undefined || item[field] === '';
        case "IS NOT NULL":
            return item[field] !== null && item[field] !== undefined && item[field] !== '';
        default:
            return true;
    }
};
export const FreeTextFilterCondition = (item, field, condition, value) => {
    const fieldValue = item[field];
    switch (condition) {
        case "=":
            return fieldValue && typeof fieldValue === 'string' && fieldValue.toUpperCase() === value.toUpperCase();
        case "!=":
            return fieldValue && typeof fieldValue === 'string' && fieldValue.toUpperCase() !== value.toUpperCase();
        case "starts_with":
            return fieldValue && typeof fieldValue === 'string' && fieldValue.toUpperCase().startsWith(value.toUpperCase());
        case "ends_with":
            return fieldValue && typeof fieldValue === 'string' && fieldValue.toUpperCase().endsWith(value.toUpperCase());
        case "contains":
            return fieldValue && typeof fieldValue === 'string' && fieldValue.toUpperCase().includes(value.toUpperCase());
        case "NOT LIKE":
            return !fieldValue || (typeof fieldValue !== 'string' || !fieldValue.toUpperCase().includes(value.toUpperCase()));
        case "IS NULL":
            return fieldValue === null || fieldValue === undefined || fieldValue === '';
        case "IS NOT NULL":
            return fieldValue !== null && fieldValue !== undefined && fieldValue !== '';
        default:
            return true;

    }
};
export const NumberFilterCondition = (item, field, condition, value) => {
    const fieldValue = parseInt(item[field], 10);
    const numericValue = parseInt(value, 10);

    switch (condition) {
        case "=":
            return fieldValue === numericValue;
        case "!=":
            return fieldValue !== numericValue;
        case ">":
            return fieldValue > numericValue;
        case "<":
            return fieldValue < numericValue;
        case "<=":
            return fieldValue <= numericValue;
        case ">=":
            return fieldValue >= numericValue;
        case "IS NULL":
            return Number.isNaN(fieldValue) || fieldValue === null || fieldValue === undefined;
        case "IS NOT NULL":
            return !Number.isNaN(fieldValue) && fieldValue !== null && fieldValue !== undefined;
        default:
            return true;
    }
};
export const BooleanFilterCondition = (item, field, condition, value) => {
    switch (condition) {
        case "=":
            return item[field] === value;
        case "!=":
            return item[field] !== value;
        default:
            return true;
    }
};

function extractTimeZoneName(tzString) {
    const parts = tzString.split(" ");
    return parts[1];
}

export const DateFilterCondition = (item, field, condition, value, companyProfile, profile) => {
    const tzString = profile?.timeZone || "(GMT+0:00) UTC";
    const tz = extractTimeZoneName(tzString);
    const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm")
    const getMonthIndex = (monthName) => {
        const months = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        return months.findIndex(
            m => m.toLowerCase() === monthName.toLowerCase()
        );
    };
    const fiscalStartMonthIndex = getMonthIndex(companyProfile.monthName);
    const dateConvert = moment(item[field], ['DD-MM-YYYY', 'MM-DD-YYYY', 'YYYY-MM-DD'], true).format('YYYY-MM-DD');
    const fieldValue = new Date(dateConvert);
    const filterValue = new Date(value);

    // Financial Year Calculations
    const today = new Date(currentrealTime);
    const thisMonth = today.getMonth();
    const thisYear = today.getFullYear();

    // Fiscal Year ends in the month before the next fiscal start month
    // So if today is May 2025 and FY ends in August, we're in FY 2025
    const fiscalYear =
        thisMonth >= fiscalStartMonthIndex ? thisYear + 1 : thisYear;
    // Fiscal Year Ranges
    const startOfFinancialYear = new Date(fiscalYear - 1, fiscalStartMonthIndex, 1);
    const endOfFinancialYear = new Date(fiscalYear, fiscalStartMonthIndex, 0);
    endOfFinancialYear.setHours(23, 59, 59, 999);
    // Previous Fiscal Year
    const startOfLastFinancialYear = new Date(fiscalYear - 2, fiscalStartMonthIndex, 1);
    const endOfLastFinancialYear = new Date(fiscalYear - 1, fiscalStartMonthIndex, 0);
    endOfLastFinancialYear.setHours(23, 59, 59, 999);

    // Next Fiscal Year
    const startOfNextFinancialYear = new Date(fiscalYear, fiscalStartMonthIndex, 1);
    const endOfNextFinancialYear = new Date(fiscalYear + 1, fiscalStartMonthIndex, 0);
    endOfNextFinancialYear.setHours(23, 59, 59, 999);

    // Quarter Calculations   penfig for the end dates
    // Fiscal Quarter (based on fiscal year starting at monthIndex)
    const monthsSinceFiscalStart = (thisMonth - fiscalStartMonthIndex + 12) % 12;
    const fiscalQuarterIndex = Math.floor(monthsSinceFiscalStart / 3);

    // Start of fiscal quarter
    const startOfQuarter = new Date(startOfFinancialYear);
    startOfQuarter.setMonth(fiscalStartMonthIndex + fiscalQuarterIndex * 3, 1);
    const endOfQuarter = new Date(startOfQuarter);
    endOfQuarter.setMonth(endOfQuarter.getMonth() + 3, 0);
    endOfQuarter.setHours(23, 59, 59, 999);

    // Previous quarter
    const startOfLastQuarter = new Date(startOfQuarter);
    startOfLastQuarter.setMonth(startOfLastQuarter.getMonth() - 3, 1);
    const endOfLastQuarter = new Date(startOfLastQuarter);
    endOfLastQuarter.setMonth(endOfLastQuarter.getMonth() + 3, 0);
    endOfLastQuarter.setHours(23, 59, 59, 999);
    // Next quarter
    const startOfNextQuarter = new Date(startOfQuarter);
    startOfNextQuarter.setMonth(startOfNextQuarter.getMonth() + 3, 1);
    const endOfNextQuarter = new Date(startOfNextQuarter);
    endOfNextQuarter.setMonth(endOfNextQuarter.getMonth() + 3, 0);
    endOfNextQuarter.setHours(23, 59, 59, 999);
    switch (condition) {
        case "=":
            return fieldValue.getTime() === filterValue.getTime();
        case "!=":
            return fieldValue.getTime() !== filterValue.getTime();
        case "<":
            return fieldValue.getTime() < filterValue.getTime();
        case ">":
            return fieldValue.getTime() > filterValue.getTime();
        case "today": {
            const today = new Date(currentrealTime);
            return fieldValue.toDateString() === today.toDateString();
        }
        case "tomorrow": {
            const tomorrow = new Date(currentrealTime);
            tomorrow.setDate(tomorrow.getDate() + 1);
            return fieldValue.toDateString() === tomorrow.toDateString();
        }
        case "yesterday": {
            const yesterday = new Date(currentrealTime);
            yesterday.setDate(yesterday.getDate() - 1);
            return fieldValue.toDateString() === yesterday.toDateString();
        }
        case "this_week": {
            const startOfWeek = new Date(currentrealTime);
            startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay());
            startOfWeek.setHours(0, 0, 0, 0);
            const endOfWeek = new Date(startOfWeek);
            endOfWeek.setDate(endOfWeek.getDate() + 6);
            endOfWeek.setHours(23, 59, 59, 999);
            return fieldValue >= startOfWeek && fieldValue <= endOfWeek;
        }
        case "last_week": {
            // const lastWeekStart = new Date(currentrealTime);
            // lastWeekStart.setDate(lastWeekStart.getDate() - (lastWeekStart.getDay() + 6));
            // lastWeekStart.setHours(0, 0, 0, 0);
            // const lastWeekEnd = new Date(lastWeekStart);
            // lastWeekEnd.setDate(lastWeekEnd.getDate() + 6);
            // lastWeekEnd.setHours(23, 59, 59, 999);
            // return fieldValue >= lastWeekStart && fieldValue <= lastWeekEnd;
            const today = new Date(currentrealTime);
            const day = today.getDay();
            const lastWeekStart = new Date(today);
            lastWeekStart.setDate(today.getDate() - day - 7);
            lastWeekStart.setHours(0, 0, 0, 0);
            const lastWeekEnd = new Date(lastWeekStart);
            lastWeekEnd.setDate(lastWeekStart.getDate() + 6);
            lastWeekEnd.setHours(23, 59, 59, 999);
            return fieldValue >= lastWeekStart && fieldValue <= lastWeekEnd;
        }
        case "next_week": {
            const nextWeekStart = new Date(currentrealTime);
            nextWeekStart.setDate(nextWeekStart.getDate() + (7 - nextWeekStart.getDay()));
            nextWeekStart.setHours(0, 0, 0, 0);
            const nextWeekEnd = new Date(nextWeekStart);
            nextWeekEnd.setDate(nextWeekEnd.getDate() + 6);
            nextWeekEnd.setHours(23, 59, 59, 999);
            return fieldValue >= nextWeekStart && fieldValue <= nextWeekEnd;
        }
        case "this_month": {
            const startOfMonth = new Date(currentrealTime);
            startOfMonth.setDate(1);
            startOfMonth.setHours(0, 0, 0, 0);
            const endOfMonth = new Date(startOfMonth);
            endOfMonth.setMonth(endOfMonth.getMonth() + 1);
            endOfMonth.setDate(0);
            endOfMonth.setHours(23, 59, 59, 999);
            return fieldValue >= startOfMonth && fieldValue <= endOfMonth;
        }
        case "last_month": {
            const lastMonthStart = new Date(currentrealTime);
            lastMonthStart.setMonth(lastMonthStart.getMonth() - 1, 1);
            lastMonthStart.setHours(0, 0, 0, 0);
            const lastMonthEnd = new Date(lastMonthStart);
            lastMonthEnd.setMonth(lastMonthEnd.getMonth() + 1, 0);
            lastMonthEnd.setHours(23, 59, 59, 999);
            return fieldValue >= lastMonthStart && fieldValue <= lastMonthEnd;
        }
        case "next_month": {
            const nextMonthStart = new Date(currentrealTime);
            nextMonthStart.setMonth(nextMonthStart.getMonth() + 1, 1);
            nextMonthStart.setHours(0, 0, 0, 0);
            const nextMonthEnd = new Date(nextMonthStart);
            nextMonthEnd.setMonth(nextMonthEnd.getMonth() + 1, 0);
            nextMonthEnd.setHours(23, 59, 59, 999);
            return fieldValue >= nextMonthStart && fieldValue <= nextMonthEnd;
        }
        case "this_financial_year":
            return fieldValue >= startOfFinancialYear && fieldValue <= endOfFinancialYear;
        case "last_financial_year":
            return fieldValue >= startOfLastFinancialYear && fieldValue <= endOfLastFinancialYear;
        case "next_financial_year":
            return fieldValue >= startOfNextFinancialYear && fieldValue <= endOfNextFinancialYear;
        case "this_quarter":
            return fieldValue >= startOfQuarter && fieldValue <= endOfQuarter;
        case "last_quarter":
            return fieldValue >= startOfLastQuarter && fieldValue <= endOfLastQuarter;
        case "next_quarter":
            return fieldValue >= startOfNextQuarter && fieldValue <= endOfNextQuarter;
        case "IS NULL":
            return Number.isNaN(fieldValue.getTime());
        case "IS NOT NULL":
            return !Number.isNaN(fieldValue.getTime());
        default:
            return true;
    }
};
export const shouldDropdownFilter = (fieldType, condition, data) => {
    return (
        fieldType !== null &&
        (
            (condition === "is_empty" || condition === "is_not_empty") ||
            (condition !== "is_empty" || condition !== "is_not_empty") && data !== null && Array.isArray(data) && data.length > 0
        )
    );
};
export const shouldFilter = (fieldType, condition, data) => {
    return (
        fieldType !== null &&
        (
            (condition === "is_empty" || condition === "is_not_empty") ||
            (condition !== "is_empty" || condition !== "is_not_empty") && data !== null && data !== ""
        )
    );
};
export const shouldDateFilter = (fieldType, condition, data) => {
    return (
        fieldType !== null &&
        (
            (condition !== "is" && condition !== "is_not" && condition !== "before" && condition !== "after") ||
            (condition === "is" || condition === "is_not" || condition === "before" || condition === "after") && data !== null && data !== ""
        )
    );
};
export async function GetExchangeRate(base, baseValue, target) {
    const Response = await getAxiosInstance().get(`/usermgmt/getExchangeRatesByValue/${base}/${baseValue}/${target}`)
    return Response.data
}
export async function convertCurrency(ConvertRate, amount) {
    const Exchange = 1 / ConvertRate;
    const convertedAmount = amount * Exchange;
    return convertedAmount;
};
export async function ExchangeCurrency(Amount, ExRate) {
    const convertedAmount = Amount * ExRate;
    return convertedAmount;
}
export async function exportToPDF(pointer) {
    const element = document.getElementById(pointer);
    const canvas = await html2canvas(element);
    const imgData = canvas.toDataURL('image/png');

    const pdf = new JsPDF('p', 'mm', 'a4');
    const imgWidth = 210;
    const pageHeight = 295;
    const imgHeight = canvas.height * imgWidth / canvas.width;
    let heightLeft = imgHeight;

    let position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
    }

    pdf.save('CxSquareReport.pdf');
};
export function startOfWeek(date) {
    const day = date.getDay();
    const diff = date.getDate() - day; // Adjust for Sunday
    const start = new Date(date); // Create a new date to avoid mutating the original
    return new Date(start.setDate(diff));
}
export function endOfWeek(date) {
    const start = startOfWeek(new Date(date)); // Create a new Date instance to avoid modifying the original date
    // return new Date(start.setDate(start.getDate() + 6)); // Saturday is 6 days after Sunday
    const lastDay = new Date(start.setDate(start.getDate() + 6))
    lastDay.setHours(23, 59, 59, 999);
    return lastDay;
}
export function startOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
}
export function endOfMonth(date) {
    const start = startOfMonth(new Date(date)); // Create a new Date instance to avoid modifying the original date
    // return new Date(start.getFullYear(), start.getMonth() + 1, 0); // Last day of the month
    const lastDay = new Date(start.getFullYear(), start.getMonth() + 1, 0);
    lastDay.setHours(23, 59, 59, 999);
    return lastDay;
}
export function startOfYear(companyProfile, currentrealTime) {
    const getMonthIndex = (monthName) => {
        const months = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        return months.findIndex(
            m => m.toLowerCase() === monthName.toLowerCase()
        );
    };
    const fiscalStartMonthIndex = getMonthIndex(companyProfile.monthName);
    const today = new Date(currentrealTime);
    const thisMonth = today.getMonth();
    const thisYear = today.getFullYear();
    const fiscalYear =
        thisMonth >= fiscalStartMonthIndex ? thisYear + 1 : thisYear;
    // return new Date(date.getFullYear(), 0, 1);
    return new Date(fiscalYear - 1, fiscalStartMonthIndex, 1);
}
export function endOfYear(companyProfile, currentrealTime) {
    const getMonthIndex = (monthName) => {
        const months = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        return months.findIndex(
            m => m.toLowerCase() === monthName.toLowerCase()
        );
    };
    const fiscalStartMonthIndex = getMonthIndex(companyProfile.monthName);
    const today = new Date(currentrealTime);
    const thisMonth = today.getMonth();
    const thisYear = today.getFullYear();
    const fiscalYear =
        thisMonth >= fiscalStartMonthIndex ? thisYear + 1 : thisYear;

    const lastDay = new Date(fiscalYear, fiscalStartMonthIndex, 0);
    lastDay.setHours(23, 59, 59, 999);
    return lastDay;
};
// const getRandomDarkerColor = (() => {
//     const presets = {
//         dark: [30, 80],
//         mediumLight: [130, 200],
//         balanced: [70, 200]
//     };

//     const colorStore = {}; // Store used colors by identifier

//     function isSimilar(hex, existing) {
//         const toRGB = h => [parseInt(h.substr(1, 2), 16), parseInt(h.substr(3, 2), 16), parseInt(h.substr(5, 2), 16)];
//         const distance = (a, b) =>
//             Math.sqrt((a[0] - b[0]) ** 2 + (a[1] - b[1]) ** 2 + (a[2] - b[2]) ** 2);
//         const rgb = toRGB(hex);
//         return existing.some(e => distance(rgb, toRGB(e)) < 40);
//     }

//     return function getRandomDarkerColor(identifier = 'default', type = 'balanced') {
//         const [min, max] = presets[type] || presets.balanced;

//         if (!colorStore[identifier]) {
//             colorStore[identifier] = [];
//         }

//         const used = colorStore[identifier];
//         let color;
//         let attempts = 0;

//         do {
//             const r = Math.floor(Math.random() * (max - min) + min);
//             const g = Math.floor(Math.random() * (max - min) + min);
//             const b = Math.floor(Math.random() * (max - min) + min);
//             color = `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
//             attempts += 1;
//         } while (isSimilar(color, used) && attempts < 50);

//         used.push(color);
//         return color;
//     };
// })();
// Distinct color generator that keeps track per chart
const getRandomDarkerColor = (() => {
    const hueCache = {}; // Keeps hues per identifier (e.g., per graph)

    function hslToHex(h, s, l) {
        s /= 100;
        l /= 100;

        const k = n => (n + h / 30) % 12;
        const a = s * Math.min(l, 1 - l);
        const f = n =>
            Math.round(255 * (l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)))));

        return `#${[f(0), f(8), f(4)]
            .map(x => x.toString(16).padStart(2, '0'))
            .join('')}`;
    }

    function isHueTooClose(h, existingHues) {
        return existingHues.some(existing => Math.abs(h - existing) < 25);
    }

    return function getRandomDarkerColor(identifier = 'default') {
        if (!hueCache[identifier]) {
            hueCache[identifier] = [];
        }

        const usedHues = hueCache[identifier];
        let hue;
        let attempts = 0;

        do {
            hue = Math.floor(Math.random() * 360);
            attempts += 1;
        } while (isHueTooClose(hue, usedHues) && attempts < 100);

        usedHues.push(hue);

        const saturation = 65 + Math.random() * 15; // rich and vibrant
        const lightness = 45 + Math.random() * 10;  // ideal for graph contrast

        return hslToHex(hue, saturation, lightness);
    };
})();
export async function processData(item, data, Row, Column, Type, GroupBy, Yaxis) {
    if (Row !== null && Column !== null) {
        const labelsSet = new Set(data.map(dataItem => dataItem[Row]));
        const labels = Array.from(labelsSet);
        if (Type !== "Stacked Vertical Bar" && Type !== "Stacked Horizontal Bar") {
            const datasets = [];
            const datas = [];
            let backgroundColors = [];
            labels.forEach(label => {
                const filteredData = data.filter(dataItem => dataItem[Row] === label);
                let sum = 0;
                filteredData.forEach(dataItem => {
                    const value = dataItem[Column];
                    if (Yaxis?.currencyType === "SCORE") {
                        const numValue = Number(value);
                        sum += Number.isNaN(numValue) ? 0 : numValue;
                    } else if (Yaxis?.currencyType === "YES") {
                        sum += value;
                    } else {
                        sum += 1; // default fallback
                    }
                    // sum += (Yaxis?.currencyType === "YES") ? value : 1;
                });
                datas.push(sum);
            });
            if (Type === "Donut" || Type === "Pie Chart") {
                labels.forEach(() => {
                    backgroundColors.push(getRandomDarkerColor());
                });
            } else {
                // backgroundColors = [getRandomDarkerColor()];
                backgroundColors = getRandomDarkerColor()
            }
            const combined = labels.map((label, i) => ({
                label: (label === null || label === "" || label === undefined) ? "Undefined" : label,
                value: datas[i],
                bg: Array.isArray(backgroundColors) ? backgroundColors[i] : backgroundColors
            }));
            combined.sort((a, b) => b.value - a.value);
            const defined = combined.filter(d => d.label !== "Undefined");
            const undefinedOnes = combined.filter(d => d.label === "Undefined");
            const finalSorted = [...defined, ...undefinedOnes];
            labels.splice(0, labels.length, ...finalSorted.map(d => d.label));
            datas.splice(0, datas.length, ...finalSorted.map(d => d.value));
            if (Array.isArray(backgroundColors)) {
                backgroundColors = finalSorted.map(d => d.bg);
            }
            datasets.push({
                data: datas,
                backgroundColor: backgroundColors,
            });
            item.datasets = datasets;
            item.Sumtotal = datas.reduce((accumulator, currentValue) => accumulator + Number(currentValue || 0), 0);
            if (Type === "Line Graph") {
                item.datasets[0].borderWidth = 1;
                item.datasets[0].fill = false;
            }
            if (Type === "Vertical Bar" || Type === "Horizontal Bar") {
                item.datasets[0].barPercentage = 0.6;
            }
            const updatedData = labels.map(raw => (raw === null || raw === '' || raw === undefined ? 'Undefined' : raw));
            item.labels = updatedData;
        }
        if ((Type === "Stacked Vertical Bar" || Type === "Stacked Horizontal Bar") && GroupBy !== null) {
            const datasets = [];
            const groupBySet = new Set(data.map(raw => raw[GroupBy]));
            const groupByValues = Array.from(groupBySet);
            groupByValues.forEach(value => {
                const filteredData = data.filter(raw => raw[GroupBy] === value);
                const datas = labels.map(label => {
                    const filteredLabelData = filteredData.filter(raw => raw[Row] === label);
                    return filteredLabelData.reduce((sum, raw) => {
                        const rawValue = raw[Column];
                        if (Yaxis?.currencyType === "SCORE") {
                            const numValue = Number(rawValue);
                            return sum + Number.isNaN(numValue) ? 0 : numValue;
                        }
                        if (Yaxis?.currencyType === "YES") {
                            return sum + rawValue;
                        }
                        return sum + 1;
                    }, 0)
                    // return filteredLabelData.reduce((sum, raw) => sum + ((Yaxis?.currencyType === "YES") ? raw[Column] : 1), 0);
                });
                datasets.push({
                    data: datas,
                    backgroundColor: getRandomDarkerColor(),
                    barPercentage: 0.6,
                    groupLables: value === null || value === '' || value === undefined ? 'Undefined' : value
                });
            });

            const totals = labels.map((_, i) =>
                datasets.reduce((sum, ds) => sum + Number(ds.data[i] || 0), 0)
            );

            const combined = labels.map((label, i) => ({
                label: (label === null || label === "" || label === undefined) ? "Undefined" : label,
                values: datasets.map(ds => ds.data[i]),
                total: totals[i]
            }));

            combined.sort((a, b) => b.total - a.total);

            const defined = combined.filter(d => d.label !== "Undefined");
            const undefinedOnes = combined.filter(d => d.label === "Undefined");
            const finalSorted = [...defined, ...undefinedOnes];

            // Rebuild arrays
            const sortedLabels = finalSorted.map(d => d.label);
            const sortedDatasets = datasets.map((ds, dsIdx) => ({
                ...ds,
                data: finalSorted.map(d => d.values[dsIdx])
            }));
            item.labels = sortedLabels;
            item.datasets = sortedDatasets;
            item.Sumtotal = datasets.reduce((accumulator, currentObj) => {
                const sumOfData = currentObj.data.reduce((sum, value) => sum + Number(value || 0), 0);
                return accumulator + sumOfData;
            }, 0);
        }
    }
    return item;
};
export async function processFilters(filters, dateFieldName, Column, Type, GroupBy, Yaxis) {
    const processedData = await Promise.all(
        filters.map((filter) => {
            return processData(filter.type, filter.data, dateFieldName, Column, Type, GroupBy, Yaxis);
        })
    );
    return processedData;
};
export async function processGraphData(originalData, dateFieldName, Column, Type, dateFilter, GroupBy, Yaxis, companyProfile, profile) {
    const tzString = profile?.timeZone || "(GMT+0:00) UTC";
    const tz = extractTimeZoneName(tzString);
    const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm")
    const now = new Date(currentrealTime);
    const thisWeekStart = startOfWeek(now);
    const thisWeekEnd = endOfWeek(now);
    const thisMonthStart = startOfMonth(now);
    const thisMonthEnd = endOfMonth(now);
    const thisYearStart = startOfYear(companyProfile, currentrealTime);
    const thisYearEnd = endOfYear(companyProfile, currentrealTime);
    const weekData = originalData.filter(item => {
        const itemDate = new Date(item[dateFieldName]);
        return itemDate >= thisWeekStart && itemDate <= thisWeekEnd;
    });
    const monthData = originalData.filter(item => {
        const itemDate = new Date(item[dateFieldName]);
        return itemDate >= thisMonthStart && itemDate <= thisMonthEnd;
    });
    const yearData = originalData.filter(item => {
        const itemDate = new Date(item[dateFieldName]);
        return itemDate >= thisYearStart && itemDate <= thisYearEnd;
    });
    const filters = [
        { type: dateFilter.weekData, data: weekData },
        { type: dateFilter.yearData, data: yearData },
        { type: dateFilter.monthData, data: monthData }
    ];
    const FormateData = await processFilters(filters, dateFieldName, Column, Type, GroupBy, Yaxis);
    return {
        weekData: FormateData[0],
        yearData: FormateData[1],
        monthData: FormateData[2],
    };
};
export async function checkAccountPresence(entityId, entityDataList, entity) {
    let Data;
    if (!entityId || !Array.isArray(entityDataList)) {
        return { isPresent: false, sharingId: null };
    }
    if (entity === "Lead") {
        Data = entityDataList.find(item => item.leads_id === entityId);
    }
    if (entity === "Contact") {
        Data = entityDataList.find(item => item.contacts_id === entityId);
    }
    if (entity === "Account") {
        Data = entityDataList.find(item => item.account_id === entityId);
    }
    if (entity === "Deal") {
        Data = entityDataList.find(item => item.deals_id === entityId);
    }
    if (entity === "Quote") {
        Data = entityDataList.find(item => item.quotesId === entityId);
    }
    if (entity === "SalesOrder") {
        Data = entityDataList.find(item => item.salesOrderId === entityId);
    }
    if (entity === "Invoice") {
        Data = entityDataList.find(item => item.invoiceId === entityId);
    }
    if (entity === "Case") {
        Data = entityDataList.find(item => item.caseId === entityId);
    }
    if (Data) {
        return { isPresent: true, sharingId: Data.fromId, entityData: Data };
    }
    return { isPresent: false, sharingId: null };
};
export async function processData2(item, data, Row, Column, Type, GroupBy, Source, SortData) {
    if (Row !== null && Column !== null) {

        if (Type !== "Stacked Vertical Bar" && Type !== "Stacked Horizontal Bar") {
            const labelsSet = new Set(data.map(dataItem => dataItem[Row]));
            const labels = Array.from(labelsSet);
            const datasets = [];
            const datas = [];
            let backgroundColors = [];
            labels.forEach(label => {
                const filteredData = data.filter(dataItem => dataItem[Row] === label);
                let sum = 0;
                filteredData.forEach(dataItem => {
                    const value = dataItem[Column];
                    sum += (Source === "Sum") ? value : 1;
                });
                datas.push(sum);
            });
            if (Type === "Donut" || Type === "Pie Chart") {
                labels.forEach(() => {
                    backgroundColors.push(getRandomDarkerColor());
                });
            } else {
                // backgroundColors = [getRandomDarkerColor()];
                backgroundColors = getRandomDarkerColor()
            }
            if (SortData) {
                const combined = labels.map((label, i) => ({
                    label: (label === null || label === "" || label === undefined) ? "Undefined" : label,
                    value: datas[i],
                    bg: Array.isArray(backgroundColors) ? backgroundColors[i] : backgroundColors
                }));
                combined.sort((a, b) => b.value - a.value);
                const defined = combined.filter(d => d.label !== "Undefined");
                const undefinedOnes = combined.filter(d => d.label === "Undefined");
                const finalSorted = [...defined, ...undefinedOnes];
                labels.splice(0, labels.length, ...finalSorted.map(d => d.label));
                datas.splice(0, datas.length, ...finalSorted.map(d => d.value));
                if (Array.isArray(backgroundColors)) {
                    backgroundColors = finalSorted.map(d => d.bg);
                }
            }
            datasets.push({
                data: datas,
                backgroundColor: backgroundColors,
            });
            item.datasets = datasets;
            item.Sumtotal = datas.reduce((accumulator, currentValue) => accumulator + Number(currentValue || 0), 0);
            if (Type === "Line Graph") {
                item.datasets[0].borderWidth = 1;
                item.datasets[0].fill = false;
            }
            if (Type === "Vertical Bar" || Type === "Horizontal Bar") {
                item.datasets[0].barPercentage = 0.6;
            }
            const updatedData = labels.map(raw => (raw === null || raw === '' || raw === undefined ? 'Undefined' : raw));
            item.labels = updatedData;
        }
        if ((Type === "Stacked Vertical Bar" || Type === "Stacked Horizontal Bar") && GroupBy !== null) {
            const labelsSet = new Set(data.map(dataItem => dataItem[Row]));
            const labels = Array.from(labelsSet);
            const datasets = [];
            const groupBySet = new Set(data.map(raw => raw[GroupBy]));
            const groupByValues = Array.from(groupBySet);
            groupByValues.forEach(value => {
                const filteredData = data.filter(raw => raw[GroupBy] === value);
                const datas = labels.map(label => {
                    const filteredLabelData = filteredData.filter(raw => raw[Row] === label);
                    return filteredLabelData.reduce((sum, raw) => sum + ((Source === "Sum") ? raw[Column] : 1), 0);
                });
                datasets.push({
                    data: datas,
                    backgroundColor: getRandomDarkerColor(),
                    barPercentage: 0.6,
                    groupLables: value === null || value === '' || value === undefined ? 'Undefined' : value
                });
            });
            if (SortData) {
                const totals = labels.map((_, i) =>
                    datasets.reduce((sum, ds) => sum + Number(ds.data[i] || 0), 0)
                );

                const combined = labels.map((label, i) => ({
                    label: (label === null || label === "" || label === undefined) ? "Undefined" : label,
                    values: datasets.map(ds => ds.data[i]),
                    total: totals[i]
                }));

                combined.sort((a, b) => b.total - a.total);

                const defined = combined.filter(d => d.label !== "Undefined");
                const undefinedOnes = combined.filter(d => d.label === "Undefined");
                const finalSorted = [...defined, ...undefinedOnes];

                // Rebuild arrays
                const sortedLabels = finalSorted.map(d => d.label);
                const sortedDatasets = datasets.map((ds, dsIdx) => ({
                    ...ds,
                    data: finalSorted.map(d => d.values[dsIdx])
                }));
                item.labels = sortedLabels;
                item.datasets = sortedDatasets;
            } else {
                const updatedData = labels.map((raw) => raw === null || raw === "" || raw === undefined ? "Undefined" : raw);
                item.labels = updatedData;
                item.datasets = datasets;
            }
            item.Sumtotal = datasets.reduce((accumulator, currentObj) => {
                const sumOfData = currentObj.data.reduce((sum, value) => sum + Number(value || 0), 0);
                return accumulator + sumOfData;
            }, 0);
        }
    }
    return item;
};
export async function processFilters2(filters, dateFieldName, Column, Type, GroupBy, Source, SortData) {
    const processedData = await Promise.all(
        filters.map((filter) => {
            return processData2(filter.type, filter.data, dateFieldName, Column, Type, GroupBy, Source, SortData);
        })
    );
    return processedData;
};
export async function processGraphData2(originalData, dateFieldName, Column, Type, dateFilter, GroupBy, Source, FilterDate, SortData, companyProfile, profile) {
    const tzString = profile?.timeZone || "(GMT+0:00) UTC";
    const tz = extractTimeZoneName(tzString);
    const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm")
    const now = new Date(currentrealTime);
    const thisWeekStart = startOfWeek(now);
    const thisWeekEnd = endOfWeek(now);
    const thisMonthStart = startOfMonth(now);
    const thisMonthEnd = endOfMonth(now);
    const thisYearStart = startOfYear(companyProfile, currentrealTime);
    const thisYearEnd = endOfYear(companyProfile, currentrealTime);
    const weekData = originalData.filter(item => {
        const itemDate = new Date(item[FilterDate]);
        return itemDate >= thisWeekStart && itemDate <= thisWeekEnd;
    });
    const monthData = originalData.filter(item => {
        const itemDate = new Date(item[FilterDate]);
        return itemDate >= thisMonthStart && itemDate <= thisMonthEnd;
    });
    const yearData = originalData.filter(item => {
        const itemDate = new Date(item[FilterDate]);
        return itemDate >= thisYearStart && itemDate <= thisYearEnd;
    });
    const filters = [
        { type: dateFilter.weekData, data: weekData },
        { type: dateFilter.yearData, data: yearData },
        { type: dateFilter.monthData, data: monthData }
    ];
    const FormateData = await processFilters2(filters, dateFieldName, Column, Type, GroupBy, Source, SortData);
    return {
        weekData: FormateData[0],
        yearData: FormateData[1],
        monthData: FormateData[2],
    };
};
export async function processTwoBarData(item, data, Row, Column) {
    if (Row !== null && Column !== null) {
        const result = Object.values(
            data.reduce((acc, raw) => {
                const groupValue = raw[Row];
                const isConverted = raw[Column];
                if (!acc[groupValue]) {
                    acc[groupValue] = {
                        [Row]: groupValue,
                        addCount: 0,
                        convertedCount: 0,
                    };
                }
                acc[groupValue].addCount += 1;
                if (isConverted === 1) acc[groupValue].convertedCount += 1;
                return acc;
            }, {})
        ); item = {
            labels: result.map((raw) => (raw[Row] === null || raw[Row] === '' || raw[Row] === undefined ? 'Undefined' : raw[Row])),
            totalAdd: result.reduce((accumulator, raw) => accumulator + raw.addCount, 0),
            totalConvert: result.reduce((accumulator, raw) => accumulator + raw.convertedCount, 0),
            Add: result.map((raw) => raw.addCount),
            Convert: result.map((raw) => raw.convertedCount),
        }
    }
    return item;
};
export async function processTwoBarFilters(filters, dateFieldName, Column) {
    const processedData = await Promise.all(
        filters.map((filter) => {
            return processTwoBarData(filter.type, filter.data, dateFieldName, Column);
        })
    );
    return processedData;
};
export async function processTwoBar(originalData, dateFieldName, Column, dateFilter, FilterDate, companyProfile, profile) {
    const tzString = profile?.timeZone || "(GMT+0:00) UTC";
    const tz = extractTimeZoneName(tzString);
    const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm")
    const now = new Date(currentrealTime);
    const thisWeekStart = startOfWeek(now);
    const thisWeekEnd = endOfWeek(now);
    const thisMonthStart = startOfMonth(now);
    const thisMonthEnd = endOfMonth(now);
    const thisYearStart = startOfYear(companyProfile, currentrealTime);
    const thisYearEnd = endOfYear(companyProfile, currentrealTime);
    const weekData = originalData.filter(item => {
        const itemDate = new Date(item[FilterDate]);
        return itemDate >= thisWeekStart && itemDate <= thisWeekEnd;
    });
    const monthData = originalData.filter(item => {
        const itemDate = new Date(item[FilterDate]);
        return itemDate >= thisMonthStart && itemDate <= thisMonthEnd;
    });
    const yearData = originalData.filter(item => {
        const itemDate = new Date(item[FilterDate]);
        return itemDate >= thisYearStart && itemDate <= thisYearEnd;
    });
    const filters = [
        { type: dateFilter.weekData, data: weekData },
        { type: dateFilter.yearData, data: yearData },
        { type: dateFilter.monthData, data: monthData }
    ];
    const FormateData = await processTwoBarFilters(filters, dateFieldName, Column);
    return {
        weekData: FormateData[0],
        yearData: FormateData[1],
        monthData: FormateData[2],
    };
};
export function processTwoBarData2(item, data, Row, Column1, Column2) {
    if (Row && Column1 && Column2) {
        const groupedData = Object.values(
            data.reduce((acc, row) => {
                const groupValue = row[Row] ?? 'Undefined';
                if (!acc[groupValue]) {
                    acc[groupValue] = { [Row]: groupValue, [Column1]: 0, [Column2]: 0 };
                }
                acc[groupValue][Column1] += row.dealValue;
                acc[groupValue][Column2] += row.forcastValue;
                return acc;
            }, {})
        );

        item = {
            labels: groupedData.map((d) => d[Row]),
            totalDealValue: groupedData.reduce((sum, d) => sum + d[Column1], 0),
            totalForcast: groupedData.reduce((sum, d) => sum + d[Column2], 0),
            DealValue: groupedData.map((d) => d[Column1]),
            Forcast: groupedData.map((d) => d[Column2]),
        };
    }
    return item;
}
export async function processTwoBarFilters2(filters, dateFieldName, Column1, Column2) {
    const processedData = await Promise.all(
        filters.map((filter) => {
            return processTwoBarData2(filter.type, filter.data, dateFieldName, Column1, Column2);
        })
    );
    return processedData;
};
export async function processTwoBar2(originalData, dateFieldName, Column1, Column2, dateFilter, FilterDate, companyProfile, profile) {
    const tzString = profile?.timeZone || "(GMT+0:00) UTC";
    const tz = extractTimeZoneName(tzString);
    const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm")
    const now = new Date(currentrealTime);
    const thisWeekStart = startOfWeek(now);
    const thisWeekEnd = endOfWeek(now);
    const thisMonthStart = startOfMonth(now);
    const thisMonthEnd = endOfMonth(now);
    const thisYearStart = startOfYear(companyProfile, currentrealTime);
    const thisYearEnd = endOfYear(companyProfile, currentrealTime);
    const weekData = originalData.filter(item => {
        const itemDate = new Date(item[FilterDate]);
        return itemDate >= thisWeekStart && itemDate <= thisWeekEnd;
    });
    const monthData = originalData.filter(item => {
        const itemDate = new Date(item[FilterDate]);
        return itemDate >= thisMonthStart && itemDate <= thisMonthEnd;
    });
    const yearData = originalData.filter(item => {
        const itemDate = new Date(item[FilterDate]);
        return itemDate >= thisYearStart && itemDate <= thisYearEnd;
    });
    const filters = [
        { type: dateFilter.weekData, data: weekData },
        { type: dateFilter.yearData, data: yearData },
        { type: dateFilter.monthData, data: monthData }
    ];
    const FormateData = await processTwoBarFilters2(filters, dateFieldName, Column1, Column2);
    return {
        weekData: FormateData[0],
        yearData: FormateData[1],
        monthData: FormateData[2],
    };
};
export function convertTimezone(dateTime, fromTzString, toTzString, format = "YYYY-MM-DD HH:mm") {
    if (!dateTime || !fromTzString || !toTzString) return "";
    const extractTimezoneName = (tzStr) => {
        const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
        return match ? match[1] : "";
    };
    const fromTimezone = extractTimezoneName(fromTzString);
    const toTimezone = extractTimezoneName(toTzString);
    if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
        console.warn("Invalid timezone provided");
        return "";
    }
    return moment.tz(dateTime, fromTimezone).tz(toTimezone).format(format);
}
const convertTime = (timeStr, timeFormat) => {
    let hours;
    let minutes;
    let period;
    if (timeStr.toLowerCase().includes('am') || timeStr.toLowerCase().includes('pm')) {
        // Parse 12-hour time string
        const timeParts = timeStr.match(/(\d{1,2}):(\d{2})/);
        hours = parseInt(timeParts[1], 10);
        minutes = parseInt(timeParts[2], 10);
        period = timeStr.match(/(am|pm)/i)[0].toLowerCase();

        if (period === 'pm' && hours !== 12) {
            hours += 12;
        } else if (period === 'am' && hours === 12) {
            hours = 0;
        }
    } else {
        // Parse 24-hour time string
        const timeParts = timeStr.split(':');
        hours = parseInt(timeParts[0], 10);
        minutes = parseInt(timeParts[1], 10);
    }
    if (timeFormat === '12hrs' || timeFormat === '12-hour') {
        period = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${period}`;
    }
    // No need for an else here because we return in the if above
    if (timeFormat === '24hrs' || timeFormat === '24-hour') {
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    }
    throw new Error('Invalid time format specified');
};
export function convertAndFormatDateTime(dateTime, company, profile) {
    if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
    const extractTimezoneName = (tzStr) => {
        const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
        return match ? match[1] : "";
    };
    const fromTimezone = extractTimezoneName(company?.timeZone);
    const toTimezone = extractTimezoneName(profile?.timeZone);
    if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
        console.warn("Invalid timezone provided");
        return "";
    }
    const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
    const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
    const formattedDate = converted.format(dateFormat);
    const rawTime = converted.format("HH:mm");
    const formattedTime = convertTime(rawTime, profile?.timeFormat);

    return `${formattedDate} ${formattedTime}`;
}
export const Dateforcondition = (condition, companyProfile, profile) => {
    const tzString = profile?.timeZone || "(GMT+0:00) UTC";
    const tz = extractTimeZoneName(tzString);
    const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm")
    const getMonthIndex = (monthName) => {
        const months = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        return months.findIndex(
            m => m.toLowerCase() === monthName.toLowerCase()
        );
    };
    const fiscalStartMonthIndex = getMonthIndex(companyProfile?.monthName);
    const today = new Date(currentrealTime);
    const thisMonth = today.getMonth();
    const thisYear = today.getFullYear();
    const fiscalYear = thisMonth >= fiscalStartMonthIndex ? thisYear + 1 : thisYear;
    const startOfFinancialYear = new Date(fiscalYear - 1, fiscalStartMonthIndex, 1);
    const endOfFinancialYear = new Date(fiscalYear, fiscalStartMonthIndex, 0);
    const endOfLastFinancialYear = new Date(fiscalYear - 1, fiscalStartMonthIndex, 0);
    const endOfNextFinancialYear = new Date(fiscalYear + 1, fiscalStartMonthIndex, 0);
    const monthsSinceFiscalStart = (thisMonth - fiscalStartMonthIndex + 12) % 12;
    const fiscalQuarterIndex = Math.floor(monthsSinceFiscalStart / 3);
    const startOfQuarter = new Date(startOfFinancialYear);
    startOfQuarter.setMonth(fiscalStartMonthIndex + fiscalQuarterIndex * 3, 1);
    const endOfQuarter = new Date(startOfQuarter);
    endOfQuarter.setMonth(endOfQuarter.getMonth() + 3, 0);
    const startOfLastQuarter = new Date(startOfQuarter);
    startOfLastQuarter.setMonth(startOfLastQuarter.getMonth() - 3, 1);
    const endOfLastQuarter = new Date(startOfLastQuarter);
    endOfLastQuarter.setMonth(endOfLastQuarter.getMonth() + 3, 0);
    const startOfNextQuarter = new Date(startOfQuarter);
    startOfNextQuarter.setMonth(startOfNextQuarter.getMonth() + 3, 1);
    const endOfNextQuarter = new Date(startOfNextQuarter);
    endOfNextQuarter.setMonth(endOfNextQuarter.getMonth() + 3, 0);
    let date;
    switch (condition) {
        case "today": {
            date = today;
            break;
        }
        case "tomorrow": {
            const tomorrow = new Date(currentrealTime);
            tomorrow.setDate(tomorrow.getDate() + 1);
            date = tomorrow;
            break;
        }
        case "yesterday": {
            const yesterday = new Date(currentrealTime);
            yesterday.setDate(yesterday.getDate() - 1);
            date = yesterday;
            break;
        }
        case "this_week": {
            const startOfWeek = new Date(currentrealTime);
            startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay());
            const endOfWeek = new Date(startOfWeek);
            endOfWeek.setDate(endOfWeek.getDate() + 6);
            date = endOfWeek;
            break;
        }
        case "last_week": {
            const today = new Date(currentrealTime);
            const dayOfWeek = today.getDay();
            const lastWeekEnd = new Date(today);
            lastWeekEnd.setDate(today.getDate() - dayOfWeek - 1);
            date = lastWeekEnd;
            break;
        }
        case "next_week": {
            const nextWeekStart = new Date(currentrealTime);
            nextWeekStart.setDate(nextWeekStart.getDate() + (7 - nextWeekStart.getDay()));
            const nextWeekEnd = new Date(nextWeekStart);
            nextWeekEnd.setDate(nextWeekEnd.getDate() + 6);
            date = nextWeekEnd;
            break;
        }
        case "this_month": {
            const startOfMonth = new Date(currentrealTime);
            startOfMonth.setDate(1);
            const endOfMonth = new Date(startOfMonth);
            endOfMonth.setMonth(endOfMonth.getMonth() + 1);
            endOfMonth.setDate(0);
            date = endOfMonth;
            break;
        }
        case "last_month": {
            const lastMonthStart = new Date(currentrealTime);
            lastMonthStart.setMonth(lastMonthStart.getMonth() - 1, 1);
            const lastMonthEnd = new Date(lastMonthStart);
            lastMonthEnd.setMonth(lastMonthEnd.getMonth() + 1, 0);
            date = lastMonthEnd;
            break;
        }
        case "next_month": {
            const nextMonthStart = new Date(currentrealTime);
            nextMonthStart.setMonth(nextMonthStart.getMonth() + 1, 1);
            const nextMonthEnd = new Date(nextMonthStart);
            nextMonthEnd.setMonth(nextMonthEnd.getMonth() + 1, 0);
            date = nextMonthEnd;
            break;
        }
        case "this_financial_year":
            date = endOfFinancialYear;
            break;
        case "last_financial_year":
            date = endOfLastFinancialYear;
            break;
        case "next_financial_year":
            date = endOfNextFinancialYear;
            break;
        case "this_quarter":
            date = endOfQuarter;
            break;
        case "last_quarter":
            date = endOfLastQuarter;
            break;
        case "next_quarter":
            date = endOfNextQuarter;
            break;
        default:
            return null;
    }
    return moment(date).format("YYYY-MM-DD");
};
export const DateforQueryBuilder = (condition, fucntionType, date, companyProfile, profile) => {
    const tzString = profile?.timeZone || "(GMT+0:00) UTC";
    const tz = extractTimeZoneName(tzString);
    const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm")
    const getMonthIndex = (monthName) => {
        const months = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        return months.findIndex(m => m.toLowerCase() === monthName.toLowerCase());
    };

    const fiscalStartMonthIndex = getMonthIndex(companyProfile.monthName);
    const today = new Date(currentrealTime);
    const thisMonth = today.getMonth();
    const thisYear = today.getFullYear();
    const fiscalYear = thisMonth >= fiscalStartMonthIndex ? thisYear + 1 : thisYear;

    const startOfFinancialYear = new Date(fiscalYear - 1, fiscalStartMonthIndex, 1);
    const endOfFinancialYear = new Date(fiscalYear, fiscalStartMonthIndex, 0);
    const endOfLastFinancialYear = new Date(fiscalYear - 1, fiscalStartMonthIndex, 0);
    const endOfNextFinancialYear = new Date(fiscalYear + 1, fiscalStartMonthIndex, 0);

    const monthsSinceFiscalStart = (thisMonth - fiscalStartMonthIndex + 12) % 12;
    const fiscalQuarterIndex = Math.floor(monthsSinceFiscalStart / 3);

    const startOfQuarter = new Date(startOfFinancialYear);
    startOfQuarter.setMonth(fiscalStartMonthIndex + fiscalQuarterIndex * 3, 1);
    const endOfQuarter = new Date(startOfQuarter);
    endOfQuarter.setMonth(endOfQuarter.getMonth() + 3, 0);

    const startOfLastQuarter = new Date(startOfQuarter);
    startOfLastQuarter.setMonth(startOfLastQuarter.getMonth() - 3, 1);
    const endOfLastQuarter = new Date(startOfLastQuarter);
    endOfLastQuarter.setMonth(endOfLastQuarter.getMonth() + 3, 0);

    const startOfNextQuarter = new Date(startOfQuarter);
    startOfNextQuarter.setMonth(startOfNextQuarter.getMonth() + 3, 1);
    const endOfNextQuarter = new Date(startOfNextQuarter);
    endOfNextQuarter.setMonth(endOfNextQuarter.getMonth() + 3, 0);

    let startDate;
    let endDate;

    switch (condition) {
        case "=":
        case "!=":
        case "<":
        case ">": {
            if (!date) return null;
            const parsedDate = new Date(date);
            startDate = new Date(parsedDate);
            endDate = new Date(parsedDate);
            break;
        }
        case "today": {
            startDate = today;
            endDate = today
            break;
        }
        case "tomorrow": {
            startDate = new Date(currentrealTime);
            startDate.setDate(startDate.getDate() + 1);
            endDate = new Date(startDate);
            break;
        }
        case "yesterday": {
            startDate = new Date(currentrealTime);
            startDate.setDate(startDate.getDate() - 1);
            endDate = new Date(startDate);
            break;
        }
        case "this_week": {
            startDate = new Date(currentrealTime);
            startDate.setDate(startDate.getDate() - startDate.getDay());
            endDate = new Date(startDate);
            endDate.setDate(endDate.getDate() + 6);
            break;
        }
        case "last_week": {
            const today = new Date(currentrealTime);
            const currentDay = today.getDay();
            const startOfThisWeek = new Date(today);
            startOfThisWeek.setDate(today.getDate() - currentDay);
            startDate = new Date(startOfThisWeek);
            startDate.setDate(startOfThisWeek.getDate() - 7);
            endDate = new Date(startDate);
            endDate.setDate(startDate.getDate() + 6);
            break;
        }
        case "next_week": {
            startDate = new Date(currentrealTime);
            startDate.setDate(startDate.getDate() + (7 - startDate.getDay()));
            endDate = new Date(startDate);
            endDate.setDate(endDate.getDate() + 6);
            break;
        }
        case "this_month": {
            startDate = new Date(today.getFullYear(), today.getMonth(), 1);
            endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
            break;
        }
        case "last_month": {
            startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            endDate = new Date(today.getFullYear(), today.getMonth(), 0);
            break;
        }
        case "next_month": {
            startDate = new Date(today.getFullYear(), today.getMonth() + 1, 1);
            endDate = new Date(today.getFullYear(), today.getMonth() + 2, 0);
            break;
        }
        case "this_financial_year": {
            startDate = startOfFinancialYear;
            endDate = endOfFinancialYear;
            break;
        }
        case "last_financial_year": {
            startDate = new Date(startOfFinancialYear);
            startDate.setFullYear(startDate.getFullYear() - 1);
            endDate = endOfLastFinancialYear;
            break;
        }
        case "next_financial_year": {
            startDate = new Date(startOfFinancialYear);
            startDate.setFullYear(startDate.getFullYear() + 1);
            endDate = endOfNextFinancialYear;
            break;
        }
        case "this_quarter": {
            startDate = startOfQuarter;
            endDate = endOfQuarter;
            break;
        }
        case "last_quarter": {
            startDate = startOfLastQuarter;
            endDate = endOfLastQuarter;
            break;
        }
        case "next_quarter": {
            startDate = startOfNextQuarter;
            endDate = endOfNextQuarter;
            break;
        }
        default:
            return null;
    }
    if (fucntionType === "Date") {
        return moment(startDate).format("YYYY-MM-DD");
    }
    if (fucntionType === "Dates") {
        return {
            start: moment(startDate).format("YYYY-MM-DD"),
            end: moment(endDate).format("YYYY-MM-DD"),
        };
    }
    if (fucntionType === "DatesTime") {
        return {
            start: moment(startDate).startOf("day").format("YYYY-MM-DD HH:mm"),
            end: moment(endDate).endOf("day").format("YYYY-MM-DD HH:mm"),
        };
    }
    return null;
};
export function useExcryptedNavigation() {
    const companyData = useSelector(state => state.localRedux);
    const companyProfile = companyData.company
    const ExcryptedNavigation = async (fucntiontype, id, entity, history, dispatch, companyId, graphs) => {
        try {
            const response = await FecthModuleEncryptedToken(id, companyProfile.companyId)
            if (response.message === "Success" && response.statusCode === 200 && response.success === true) {
                if (fucntiontype !== "Return") {
                    if (dispatch) {
                        dispatch(setEditCall(false));
                    }
                    let encryptedCompanyId = null;
                    if (companyId) {
                        const companyResponse = await FecthModuleEncryptedToken(companyId, companyProfile.companyId);
                        if (companyResponse.message === "Success" && companyResponse.statusCode === 200 && companyResponse.success === true) {
                            encryptedCompanyId = companyResponse.data;
                        } else {
                            message.error("Unable to encrypt company ID. Using without encryption.");
                            encryptedCompanyId = companyId;
                        }
                    }
                    if (history) {
                        if (entity === "Shared" || entity === "Open") {
                            const url = `/Home/reports?${entity}=${response.data}${graphs ? `=${graphs}` : ""}`;
                            history.push(url);
                        } else {
                            const url = `/Home/details?${entity}=${response.data}${encryptedCompanyId ? `=${encryptedCompanyId}` : (graphs ? `=${graphs}` : "")}`;
                            history.push(url);
                        }
                    }
                } else {
                    // eslint-disable-next-line no-lonely-if
                    if (entity === "Shared") {
                        return { url: `/Home/reports?${entity}=${response.data}`, status: true }
                    }
                    return { url: `/Home/details?${entity}=${response.data}`, status: true }
                }
            }
            else {
                // eslint-disable-next-line no-lonely-if
                if (fucntiontype === "Return") {
                    return { url: "", status: false }
                }
                message.error("Unable to open the detail page. Please try again.")
            }
        }
        catch (error) {
            // eslint-disable-next-line no-lonely-if
            if (fucntiontype === "Return") {
                return { url: "", status: false }
            }
            message.error("Unable to open the detail page. Please try again.")
        }
    };
    return { ExcryptedNavigation };
}
export function useExcryptedNavigationBusinessRule() {
    const companyData = useSelector(state => state.localRedux);
    const companyProfile = companyData.company
    const ExcryptedNavigationBusinessRule = async (fucntiontype, id, entity, history, url) => {
        try {
            const response = await FecthModuleEncryptedToken(id, companyProfile.companyId)
            if (response.message === "Success" && response.statusCode === 200 && response.success === true) {
                if (fucntiontype !== "Return") {
                    if (history) {
                        const data = `${url}?${entity}=${response.data}`;
                        history.push(data);
                    }
                } else {
                    // eslint-disable-next-line no-lonely-if
                    if (entity === "Shared") {
                        return { url: `/Home/reports?${entity}=${response.data}`, status: true }
                    }
                    return { url: `/Home/details?${entity}=${response.data}`, status: true }
                }
            }
            else {
                // eslint-disable-next-line no-lonely-if
                if (fucntiontype === "Return") {
                    return { url: "", status: false }
                }
                message.error("Unable to open the detail page. Please try again.")
            }
        }
        catch (error) {
            // eslint-disable-next-line no-lonely-if
            if (fucntiontype === "Return") {
                return { url: "", status: false }
            }
            message.error("Unable to open the detail page. Please try again.")
        }
    }
    return { ExcryptedNavigationBusinessRule };
}
export function useNavigationDecrypted() {
    const companyData = useSelector(state => state.localRedux);
    const companyProfile = companyData.company
    const NavigationDecrypted = async (id) => {
        try {
            const response = await FecthModuleDecryptedToken(id, companyProfile.companyId)
            if (response.message === "Success" && response.statusCode === 200 && response.success === true) {
                return response.data;
            }
            return false;
        }
        catch (error) {
            message.error("Unable to open the detail page. Please try again.")
        }
    }
    return { NavigationDecrypted };
}